
import { mapActions, mapGetters } from 'vuex'
import store from '../../config/store'

export default {
  components: {
    Alert: () => import(/* webpackChunkName: "components" */ '@/common/components/Alert.vue'),
    LoaderSpinner: () => import(/* webpackChunkName: "components" */ '@/common/components/LoaderSpinner.vue')
  },

  data: () => ({
    store,
    loading: true
  }),

  computed: {

    ...mapGetters([
      'transferDetail'
    ]),

    transfer () {
      return this.transferDetail
    },

    hasDocument () {
      return this.transfer.operation && this.transfer.operation.documents.length
    },

    isTransferWaitValidation () {
      return this.transfer.status === 'to_validate'
    },

    isApprover () {
      if (!this.transfer.approvers || !this.transfer.approvers.length) {
        return false
      }
      return this.transfer.approvers.some(a => a.uuid === store.data.user.uuid && !a.answered_at)
    }
  },

  mounted () {
    this.loading = true
    this.getTransferDetail(store.sidepanel.dataModel.id).then(() => {
      this.loading = false
    }, () => {
      this.hideSidePanel()
    })

    this.$bus.$on('on-validate-reject-reason', this.rejectTransferRequest)
  },

  destroyed () {
    this.cancelTransferRequest()

    this.$bus.$off('on-validate-reject-reason', this.rejectTransferRequest)
  },

  methods: {
    ...mapActions([
      'getTransferDetail',
      'cancelTransferRequest',
      'validateTransfer',
      'rejectTransfer',
    ]),

    validateTransferRequest () {
      this.validateTransfer(this.transfer.id).then(response => {
        Object.assign(this.transfer, response.data)
        this.$bus.$emit('refresh-transfers-list')
        this.hideSidePanel()
      })
    },

    rejectTransferRequest (reason) {
      this.rejectTransfer({ transferId: this.transfer.id, reason }).then(response => {
        this.closeModal()
        Object.assign(this.transfer, response.data)
        this.$bus.$emit('refresh-transfers-list')
        this.hideSidePanel()
      })
    },

    requestRejectTransfer () {
      this.showModal({
        childVue: 'reject-reason',
        wrapperClass: 'modal modal--md',
        dataModel: {}
      })
    },

    getApproverStatus (approver) {
      if (approver.agree) {
        return { class: 'text-primary', label: this.$i18n.t('sidepanel.transfer_validation.status.validated') }
      }
      if (approver.agree === false) {
        return { class: 'text-red', label: this.$i18n.t('sidepanel.transfer_validation.status.refused') }
      }
      return { class: '', label: this.$i18n.t('sidepanel.transfer_validation.status.pending') }
    },

    downloadAllDocuments () {
      this.downloadFileFromUrl(`/operations/${this.transfer.operation.id}/documents/all`)
    },
  }
}
